import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/native';
import { useField, useFormikContext } from 'formik';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { View, Text, TextInput, Modal, Pressable } from 'react-native';

import {
  elRed,
  elGray,
  elLightGray
} from '../../styles/colors';

export const SellersContainer = styled(View)`
  padding: 40px;
`;

export const ModalContainer = styled(Pressable)`

`;

export const SellerShowContainer = styled(View)`
  display: inline-flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const SellerDemographicContainer = styled(View)`
  padding: 10px;
  width: 20%;
`;

export const SellerAssetsContainer = styled(View)`
  width: 48%;
  border: 1px solid black;
  background-color: ${elGray};
  border-radius: 5px;
  height: 75vh;
  padding: 10px;
`;

export const SellerContactsContainer = styled(View)`
  width: 28%;
  border: 1px solid black;
  background-color: ${elGray};
  border-radius: 5px;
  height: 75vh;
  padding: 10px;
`;

export const SellerAllAssetsContainer = styled(View)`
  width: 100%;
  border: 1px solid black;
  background-color: ${elGray};
  border-radius: 5px;
  height: fit-content;
  padding: 10px;
`;

export const ButtonContainer = styled(View)`

`;

export const TabButtonContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
`

export const TabButton = styled(Pressable)`
  border: solid black 1px;
  width: 48%;
  border-radius: 3px;
  padding: 5px;
`

export const AssetsTabButtonContainer = styled(View)`
  flex-direction: row;
  align-items: flex-start;
  margin-top: 20px;
`

export const AssetsTabButton = styled(Pressable)`
  border: solid black 2px;
  width: 20%;
  border-radius: 3px;
  padding: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${props => props.active ? elRed : elLightGray};
`

export const AssetTabButton = styled(Pressable)`
  border: solid black 2px;
  width: 15%;
  border-radius: 3px;
  padding: 5px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  background-color: ${props => props.active ? elRed : elLightGray};
`

export const AssetsTabText = styled(Text)`
  font-weight: 900:
  font-size: 20px;
  color: ${props => props.active ? 'white' : 'black'};
`
